import { Component, OnInit, OnDestroy } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { Router } from '@angular/router'
import { SharedServices } from '../../../../services/shared.services'
import { ModalService } from '../../../../services/modal.service'
import { async } from '@angular/core/testing'

@Component({
    selector: 'app-chat-history',
    templateUrl: './chat-history.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './chat-history.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../../../top/top.component.css'],
})
export class ChatHistoryComponent implements OnInit, OnDestroy  {
    hiddenModal = 'hidden'
    en = {}
    showEN = true
    dataReponse: any
    resourceUrl = 'resource'
    tmpDataSearchResponse: any[] = []
    pageSize: any = 5
    addPageSize: any = 5
    arrList: any[] = []
    dataResponse: any[] = []
    dataResponseHaveAllMessageInRoom: any[] = []
    isCallApi = false;
    isAtBottom = false;
    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices, private modalService: ModalService) {
    }

    ngOnInit() {
        this.getData()
        window.addEventListener('scroll', this.onContainerScroll, true);
        // window.addEventListener('wheel', this.onMouseWheel, true);
    }

    ngOnDestroy() {
        window.removeEventListener("scroll", this.onContainerScroll, true);
        // window.removeEventListener('wheel', this.onMouseWheel, true);
    }

    getData() {
        const resourceDataAccessLog = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                client: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(
                success => {
                    if (success) {
                        this.tmpDataSearchResponse = success['response']['client']['paths']['{}']

                        this.tmpDataSearchResponse = this.tmpDataSearchResponse.filter(data => {
                            return !!data.lastPatientCommunicationAt
                        });

                        this.tmpDataSearchResponse = this.tmpDataSearchResponse.sort(function (a, b) {
                            return (b['lastPatientCommunicationAt']) - (a['lastPatientCommunicationAt'])
                        })

                        this.dataReponse = this.tmpDataSearchResponse.slice(0, this.pageSize)
                        this.dataReponse.filter(el => this.listCommunicationId(el))
                        $('.ng-scrollbar').removeClass('-vertical')

                    }
                })
        })
    }

    listCommunicationId(roomObject) {
        if (!roomObject || roomObject.isCallApi === false) {
            return
        }
        const idRoom = roomObject._id
        const resourceUrl = 'resource'
        const map = {}
        map[idRoom] = true
        const roomId = {}
        roomId['{"clientId":"' + idRoom + '"}'] = true
        const resourceData = this.restApi.makeResourceObject({
            status: {
                client: {
                    map,
                },
                clientCommunication: {
                    paths: roomId,
                    searches: roomId,
                },
            },
        })

        this.isCallApi = true;

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const listClientMessage = success['response']['client']['map']
                    const listRoomMessage = success['response']['clientCommunication']['paths']['{"clientId":"' + idRoom + '"}']
                    for (let index = 0; index < listRoomMessage.length; index++) {
                        const element = listRoomMessage[index]
                        element['familyName'] = listClientMessage[idRoom].familyName
                        element['firstName'] = listClientMessage[idRoom].firstName
                        if (!element.type) {
                            element.type = 'Reply'
                        }
                        this.dataResponseHaveAllMessageInRoom.push(element)
                    }
                    roomObject.isCallApi = false

                    setTimeout(() => { this.isCallApi = false; }, 500);

                    this.dataResponseHaveAllMessageInRoom = this.dataResponseHaveAllMessageInRoom.sort(function (a, b) {
                        return (b['createTime']) - (a['createTime'])
                    })
                    if (this.dataResponseHaveAllMessageInRoom.length < 20) { this.onScroll(); }
                },
            )
        })
    }

    // getType(listRoomMessage){
    //     for (let index = 0; index < listRoomMessage.length; index++) {
    //         const element = listRoomMessage[index];
    //         if (element && element.isPatientCreate == true && listRoomMessage.slice(-1).pop()) {
    //             this.dataResponse = element
    //         }
    //     }
    //     for (let index = 0; index < this.dataReponse.length; index++) {
    //         const element1 = this.dataReponse[index];
    //         if (this.dataResponse['isPatientCreate'] == true) {
    //             if (element1._id == this.dataResponse['clientId']) {
    //                 element1['type'] = this.dataResponse['type']
    //                 element1['updateTimeDetail'] = this.dataResponse['createTime']
    //                 element1['_idchat'] = this.dataResponse['_id']
    //                 element1['isPatientCreate'] = this.dataResponse['isPatientCreate']
    //             }
    //         }

    //     }
    //     this.dataReponse = this.dataReponse.sort(function (a, b) {
    //         return (b['updateTimeDetail']) - (a['updateTimeDetail']);
    //     });
    // }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    selectPreview(item, itemId = '') {
        let elementId = null
        if (itemId) {
            elementId = `reply_time_${itemId}`
        }
        const arrMessage = ['showModalChatDetail', item._id, false, elementId, item.clientId, item.familyName, item.firstName]
        this.modalService.emitChange(arrMessage)
    }

    onScroll() {
        const start: any = this.pageSize
        this.pageSize += this.addPageSize
        if (start >= this.tmpDataSearchResponse.length) return;
        this.dataReponse = this.tmpDataSearchResponse.slice(start, this.pageSize)
         this.dataReponse.filter(el => {
            this.listCommunicationId(el)
         })

        $('.ng-scrollbar').removeClass('-vertical')
    }

    selectChatDetail(id) {
        this.router.navigateByUrl('/app/main/client/edit/' + id + '/communication')
    }
     onContainerScroll = (event): void => {
         if (event.target.offsetHeight + event.target.scrollTop +800 >= event.target.scrollHeight) {
             this.isAtBottom = true;
         } else {
             this.isAtBottom = false;
         }
    }

    onMouseWheel = (event): void => {
        if (event.deltaY >= 0) {
            if (!this.isCallApi && this.isAtBottom) {
                this.isCallApi = true;
                this.onScroll();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/status/chat-history/chat-history.component.ts